import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from "@angular/core";
import { StepDto } from "@api";
import { IonSlides } from "@ionic/angular";

@Component({
  selector: "app-challenge-layout",
  templateUrl: "./challenge-layout.component.html",
  styleUrls: ["./challenge-layout.component.scss"],
})
export class ChallengeLayoutComponent implements OnChanges {
  @Input() public challengeSteps: StepDto[];
  @Input() public selected: StepDto;

  @Output() public stepChanged: EventEmitter<StepDto> = new EventEmitter();

  @ViewChild(IonSlides) private ionSlides: IonSlides;

  public ngOnChanges(changes: SimpleChanges): void {
    const chapterSteps: StepDto[] = changes.challengeSteps?.currentValue;
    const selected: StepDto = changes.selected?.currentValue;

    if (chapterSteps?.length && !!selected) {
      const index = chapterSteps.findIndex(step => step.id === selected.id);
      this.ionSlides?.slideTo(index - 1);
    }
  }
}
